export const setFbbPlans = 'SET_FBB_PLANS'
export const setBoosterPlans = 'SET_BOOSTER_PLANS'
